import Model, { attr } from '@ember-data/model';
import adapter from 'garaje/utils/decorators/adapter';

@adapter('v3')
class WelcomeScreenSlideModel extends Model {
  @attr('string') declare image: string;
}

export default WelcomeScreenSlideModel;

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'welcome-screen-slide': WelcomeScreenSlideModel;
  }
}
